/**
 * Service for managing SOP-specific settings
 */
import { appSettingsService, AppSettings } from './appSettingsService';

// Export the SOPSettings type from AppSettings
export type SOPSettings = Pick<AppSettings, 'showSOPFlaggingFeature' | 'autoGenerateSummaries'>;

/**
 * Service for managing SOP settings
 */
export const sopSettingsService = {
  /**
   * Get SOP settings
   * @returns Promise resolving to SOP settings
   */
  async getSettings(): Promise<SOPSettings> {
    const settings = await appSettingsService.getSettings();
    return {
      showSOPFlaggingFeature: settings.showSOPFlaggingFeature,
      autoGenerateSummaries: settings.autoGenerateSummaries
    };
  },

  /**
   * Toggle SOP flagging feature
   * @param enabled Whether the flagging feature should be enabled
   * @returns Promise resolving when update is complete
   */
  async toggleSOPFlaggingFeature(enabled: boolean): Promise<void> {
    return appSettingsService.toggleSOPFlaggingFeature(enabled);
  },
  
  /**
   * Toggle auto-generation of summaries
   * @param enabled Whether auto-generation should be enabled
   * @returns Promise resolving when update is complete
   */
  async toggleAutoGenerateSummaries(enabled: boolean): Promise<void> {
    return appSettingsService.toggleAutoGenerateSummaries(enabled);
  }
};

export default sopSettingsService;